/* eslint-disable @typescript-eslint/no-extraneous-class */
export class Measurement {
    static km2miles(km: number): number {
        const res = km * 0.621371;
        if (isNaN(res)) {
            return 0.0;
        } else {
            return Math.round(res);
        }
    }

    static imperialTons2Kg(tons: number): number {
        const res = tons * 907.185;
        if (isNaN(res)) {
            return 0.0;
        } else {
            return Math.round(res);
        }
    }

    static kg2ImperialTons(kgs: number): number {
        const res = kgs * (1.0 / 907.185);
        if (isNaN(res)) {
            return 0.0;
        } else {
            return Math.round(res);
        }
    }

    static miles2km(miles: number): number {
        const res = miles * (1 / 0.621371);
        if (isNaN(res)) {
            return 0.0;
        } else {
            return Math.round(res);
        }
    }

    static pounds2kg(pounds: number) {
        const res = pounds * 0.453592;
        if (isNaN(res)) {
            return 0.0;
        } else {
            return Math.round(res);
        }
    }

    static kg2pounds(kgs: number) {
        const res = kgs * 2.20462;
        if (isNaN(res)) {
            return 0.0;
        } else {
            return Math.round(res);
        }
    }

    static solidRate(value: number, isMetric: boolean): number {
        if (isMetric) {
            return value;
        } else {
            return value * (1.0 / 0.281849);
        }
    }

    static liquidRate(value: number, isMetric: boolean): number {
        if (isMetric) {
            return value;
        } else {
            return value * (1.0 / 2.35215);
        }
    }

    static mass(value: number, isMetric: boolean): number {
        if (isMetric) {
            return value;
        } else {
            return value * (1.0 / 0.453592);
        }
    }

    static volume(value: number, isMetric: boolean): number {
        if (isMetric) {
            return value;
        } else {
            return value * (1.0 / 3.78541);
        }
    }
}
